import { useFetchDataEventMixin } from '@goodt-common/mixins';
import { ElemDatasetDrilldownMixin } from './ElemDatasetDrilldownMixin';
import { ElemDatasetDeviationsMixin } from './ElemDatasetDeviationsMixin';
import { ElemDatasetBaseMixin } from "./ElemDatasetBaseMixin";
import { DATASET_PROP } from '../consts';
import { useDatasetMeta } from '../utils';

export const useElemDatasetBaseMixin = ({
    prop = DATASET_PROP,
    drilldown = false,
    deviations = false,
    panel = { isMultiple: true },
    fetchEvent = { methodName: 'loadData' }
} = {}) => {
    // use same ElemDatasetBaseMixin reference for most cases
    const meta = useDatasetMeta(
        {},
        {
            prop,
            panel,
            deviations
        }
    );

    return {
        mixins: [
            ElemDatasetBaseMixin,
            useFetchDataEventMixin(fetchEvent),
            ...(drilldown ? [ElemDatasetDrilldownMixin] : []),
            ...(deviations ? [ElemDatasetDeviationsMixin] : []),
            {
                meta,
                static: {
                    DATASET_PROP: prop
                }
            }
        ]
    };
};
